import * as React from 'react'
import { Link } from 'gatsby'
import { routes } from 'config'
import {
  Button,
  ConfigProvider,
  Empty,
  Table,
  TableProps,
  Tag,
} from 'components/common'
import { price } from 'lib/str-formatter'

export interface Transaction {
  id: string | number
  date: string
  number: string | number
  type: string
  amount?: number
  balance?: number
  note?: string
  slip?: React.ReactNode
  member?: string
}

export interface LedgersTableProps extends TableProps<Transaction> {
  openAddModal: () => void
  itemStatus: string
  subjectsDataLength?: number
}

const colmuns = [
  {
    title: 'No.',
    dataIndex: 'number',
    width: '10%',
  },
  {
    title: '日付',
    dataIndex: 'date',
    width: '12%',
  },
  {
    title: '区分',
    dataIndex: 'type',
    width: '10%',
    render: (value: string) => {
      switch (value) {
        case '入金':
          return <Tag color="green">{value}</Tag>
        case '出金':
          return <Tag color="red">{value}</Tag>
        default:
          return <Tag color="yellow">{value}</Tag>
      }
    },
  },
  {
    title: '金額',
    dataIndex: 'amount',
    width: '18%',
    render: (value: number) => {
      if (value >= 0) return <span>{price(value)}</span>
      else return <span className="text-red-500">{price(value)}</span>
    },
  },
  {
    title: '残高',
    dataIndex: 'balance',
    width: '18%',
    render: (value: number) => {
      if (value >= 0) return <span>{price(value)}</span>
      else return <span className="text-red-500">{price(value)}</span>
    },
  },
  {
    title: '備考',
    dataIndex: 'note',
    width: '',
    ellipsis: true,
  },
  {
    dataIndex: 'slip',
    width: '8%',
  },
]

export const LedgersTable = ({
  dataSource,
  itemStatus,
  subjectsDataLength,
  openAddModal,
  ...rest
}: LedgersTableProps) => {
  const isDataEmpty = dataSource?.length <= 0 && subjectsDataLength <= 0

  const customizeEmpty = (): JSX.Element => (
    <Empty
      description={
        <>
          {itemStatus === 'ARCHIVED' ? (
            <>
              <div className="text-2xl">データがありません</div>
            </>
          ) : isDataEmpty ? (
            <div className="text-2xl">現金出納項目を登録してください</div>
          ) : (
            <>
              <div className="text-2xl">入出金データがありません</div>
              <div>データを登録してください</div>
            </>
          )}
        </>
      }
    >
      {itemStatus !== 'ARCHIVED' &&
        (isDataEmpty ? (
          <Button type="primary">
            <Link to={routes.ledgerItemsNew}>項目を追加する</Link>
          </Button>
        ) : (
          <Button type="primary" onClick={openAddModal}>
            入出金を追加する
          </Button>
        ))}
    </Empty>
  )
  return (
    <ConfigProvider renderEmpty={customizeEmpty}>
      <Table<Transaction> dataSource={dataSource} columns={colmuns} {...rest} />
    </ConfigProvider>
  )
}
